import { ResponsiveStyleValue, Theme } from "@mui/system"

const UISK_MUI_SPACING_MAP = {
  ["none"]: "0px",
  ["xxs"]: "2px",
  ["xs"]: "4px",
  ["md"]: "8px",
  ["lg"]: "12px",
  ["xl"]: "16px",
  ["2xl"]: "20px",
  ["3xl"]: "24px",
  ["4xl"]: "32px",
  ["6xl"]: "48px",
  ["7xl"]: "64px",
  ["8xl"]: "80px",
  ["9xl"]: "96px",
  ["10xl"]: "128px",
  ["11xl"]: "160px",
  ["sm"]: "6px",
  ["5xl"]: "40px",
}

type UISK_SPACING_TYPE = typeof UISK_MUI_SPACING_MAP

type UISK_SPACING_KEY = keyof UISK_SPACING_TYPE

type SpacingProp =
  | UISK_SPACING_KEY
  | ((theme: Theme) => ResponsiveStyleValue<number | string>)

export interface UiskSpacingProps {
  gap?: SpacingProp
  columnGap?: SpacingProp
  rowGap?: SpacingProp
  m?: SpacingProp
  margin?: SpacingProp
  mb?: SpacingProp
  marginBottom?: SpacingProp
  ml?: SpacingProp
  marginLeft?: SpacingProp
  mr?: SpacingProp
  marginRight?: SpacingProp
  mt?: SpacingProp
  marginTop?: SpacingProp
  mx?: SpacingProp
  marginX?: SpacingProp
  my?: SpacingProp
  marginY?: SpacingProp
  marginInline?: SpacingProp
  marginInlineStart?: SpacingProp
  marginInlineEnd?: SpacingProp
  marginBlock?: SpacingProp
  marginBlockStart?: SpacingProp
  marginBlockEnd?: SpacingProp
  p?: SpacingProp
  padding?: SpacingProp
  pb?: SpacingProp
  paddingBottom?: SpacingProp
  pl?: SpacingProp
  paddingLeft?: SpacingProp
  pr?: SpacingProp
  paddingRight?: SpacingProp
  pt?: SpacingProp
  paddingTop?: SpacingProp
  px?: SpacingProp
  paddingX?: SpacingProp
  py?: SpacingProp
  paddingY?: SpacingProp
  paddingInline?: SpacingProp
  paddingInlineStart?: SpacingProp
  paddingInlineEnd?: SpacingProp
  paddingBlock?: SpacingProp
  paddingBlockStart?: SpacingProp
  paddingBlockEnd?: SpacingProp
}

export const uiskMuiSpacingMap = ({
  gap,
  columnGap,
  rowGap,
  m,
  margin,
  mb,
  marginBottom,
  ml,
  marginLeft,
  mr,
  marginRight,
  mt,
  marginTop,
  mx,
  marginX,
  my,
  marginY,
  marginInline,
  marginInlineStart,
  marginInlineEnd,
  marginBlock,
  marginBlockStart,
  marginBlockEnd,
  p,
  padding,
  pb,
  paddingBottom,
  pl,
  paddingLeft,
  pr,
  paddingRight,
  pt,
  paddingTop,
  px,
  paddingX,
  py,
  paddingY,
  paddingInline,
  paddingInlineStart,
  paddingInlineEnd,
  paddingBlock,
  paddingBlockStart,
  paddingBlockEnd,
}: UiskSpacingProps) => {
  const uiskSpacingProps = {
    gap,
    columnGap,
    rowGap,
    m,
    margin,
    mb,
    marginBottom,
    ml,
    marginLeft,
    mr,
    marginRight,
    mt,
    marginTop,
    mx,
    marginX,
    my,
    marginY,
    marginInline,
    marginInlineStart,
    marginInlineEnd,
    marginBlock,
    marginBlockStart,
    marginBlockEnd,
    p,
    padding,
    pb,
    paddingBottom,
    pl,
    paddingLeft,
    pr,
    paddingRight,
    pt,
    paddingTop,
    px,
    paddingX,
    py,
    paddingY,
    paddingInline,
    paddingInlineStart,
    paddingInlineEnd,
    paddingBlock,
    paddingBlockStart,
    paddingBlockEnd,
  }

  const muiSpacingProps = Object.fromEntries(
    Object.entries(uiskSpacingProps).map(([key, value]) => [
      key,
      UISK_MUI_SPACING_MAP[value as UISK_SPACING_KEY]
        ? UISK_MUI_SPACING_MAP[value as UISK_SPACING_KEY]
        : value,
    ]),
  )
  return muiSpacingProps
}
